// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal, Button, Form } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Select, { components } from 'react-select';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import AsyncSelect from 'react-select/async'
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { numberFormat } from '../helpers/GlobalHelper';
import { clampToInventoryDateBounds, getInventoryDateBounds, inventoryDateError, inventoryDateHint, resolveAccountingBackdateDays } from '../helpers/inventoryDateBounds';

interface FormData {
    idAccVouchers: number;
    voucherDate: string;
    voucherType: string;
    idProjects: string;
    idSr: string;
    idModeOfTransaction: string | null;
    chequeNo: string;
    chequeDate: string;
    transactionDate: string;
    narration: string;
}

// Define the shape of the ledger entry
type LedgerOption = any;

type Nullable<T> = T | null | undefined;

const normalizeAmountInput = (value: Nullable<string | number>): string => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
        return String(value);
    }
    return numeric.toString();
};

interface ICostCenterAllocation {
    costCenter: LedgerOption | null;
    costCenterId?: number;
    costCenterName?: string;
    amount: string;
    remarks: string;
}

interface ILedgerEntry {
    idAccVoucherRows: number | null;
    ledger: LedgerOption | null;
    drAmount: string;
    crAmount: string;
    remarks: string;
    costCenters: ICostCenterAllocation[];
}

interface JournalProps {
    show: boolean;
    handleClose: (show: boolean) => void;
    id: number;
}

const LedgerSingleValue = (props: any) => (
    <components.SingleValue {...props}>
        <div className='row'>
            <span> {props.data.label} </span>
        </div>
    </components.SingleValue>
);

const VoucherEdit: React.FC<JournalProps> = ({ show, handleClose, id }) => {

    const [isSubmitDisable] = useState(false);
    const [loading, setLoading] = useState(false);

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });

    const [companySelectAbility, setCompanySelectAbility] = useState(false);
    const [srs, setSrs] = useState([]);
    const [sr, setSr] = useState({ label: 'Select SR', value: '' });

    const voucherTypes = [
        { value: 'journal', label: 'Journal' },
        { value: 'contra', label: 'Contra' },
        { value: 'payment', label: 'Payment' },
        { value: 'receipt', label: 'Receipt' },
    ];

    const [voucherType, setVoucherType] = useState({ label: 'Journal', value: 'journal' });

    const [modeOfTransactions, setModeOfTransactions] = useState([]);
    const [modeOfTransaction, setModeOfTransaction] = useState({ label: 'Select Mode of Transaction', value: '' });

    const [defaultLedgers, setDefaultLedgers] = useState([]);

    // Define state for form fields here
    const [formData, setFormData] = useState<FormData>({
        idAccVouchers: id,
        voucherDate: '',
        voucherType: 'journal',
        idProjects: '',
        idSr: '',
        idModeOfTransaction: null,
        chequeNo: '',
        chequeDate: '',
        transactionDate: '',
        narration: '',
    });

    // Define state for form fields here
    const createEmptyEntry = (): ILedgerEntry => ({ idAccVoucherRows: null, ledger: null, drAmount: '', crAmount: '', remarks: '', costCenters: [] });
    const [entries, setEntries] = useState<ILedgerEntry[]>([
        createEmptyEntry(),
    ]);
    const [costCenterOptions, setCostCenterOptions] = useState<any[]>([]);
    const [showCostCenterModal, setShowCostCenterModal] = useState(false);
    const [activeCostCenterIndex, setActiveCostCenterIndex] = useState<number | null>(null);
    const createEmptyCostCenterRow = (): ICostCenterAllocation => ({
        costCenter: null,
        costCenterId: undefined,
        costCenterName: undefined,
        amount: '',
        remarks: '',
    });
    const [costCenterRows, setCostCenterRows] = useState<ICostCenterAllocation[]>([createEmptyCostCenterRow()]);
    const [hasLoadedVoucher, setHasLoadedVoucher] = useState(false);

    useEffect(() => {
        if (show) {
            getVoucherInfo();
        } else {
            setHasLoadedVoucher(false);
        }
    }, [show, id]);

    useEffect(() => {
        getProjects();
        getModeOfTransactions();
    }, [])

    const getModeOfTransactions = () => {
        fetch(process.env.REACT_APP_API_URL + 'mode-of-transactions', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setModeOfTransactions(
                        (resp.data || []).map((item: any) => ({
                            label: item.name,
                            value: item.id,
                        }))
                    );
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
            });
    };

    const isChequeMode = (mode: any) => {
        return mode && String(mode.label).toLowerCase() === 'cheque';
    };


    const getVoucherInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'transaction/edit/' + id,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                if (resp.success) {
                    console.log(resp.data, 'data');
                    setFormData({
                        idAccVouchers: resp.data.id_acc_vouchers,
                        voucherDate: clampToInventoryDateBounds(
                            String(resp.data.voucherDate || '').slice(0, 10),
                            resolveAccountingBackdateDays(resp.data.project)
                        ),
                        voucherType: resp.data.voucherType,
                        idProjects: resp.data.idProjects,
                        idSr: resp.data.idSr,
                        idModeOfTransaction: resp.data.idModeOfTransaction ? String(resp.data.idModeOfTransaction) : null,
                        chequeNo: resp.data.chequeNo ?? '',
                        chequeDate: resp.data.chequeDate ?? '',
                        transactionDate: resp.data.transactionDate ?? '',
                        narration: resp.data.narration ?? '',
                    });

                    setProject({
                        label: resp.data.project.projectName,
                        value: resp.data.idProjects,
                        accountingBackdateDays: resolveAccountingBackdateDays(resp.data.project),
                    });
                    setVoucherType({ label: resp.data.voucherType, value: resp.data.voucherType });

                    if (resp.data.mode_of_transaction || resp.data.modeOfTransaction) {
                        const mot = resp.data.mode_of_transaction || resp.data.modeOfTransaction;
                        setModeOfTransaction({
                            label: mot.transactionName || mot.transaction_name,
                            value: resp.data.idModeOfTransaction,
                        });
                    } else {
                        setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
                    }

                    let tempArray = resp.data.voucher_rows.map((item: any) => {
                        
                        let ledger = { 
                            id: item.ledger.id_acc_ledgers,
                            label: `${item.ledger.ledgerCode} ${item.ledger.ledgerName}`, 
                            value: item.ledger.id_acc_ledgers,
                            idBankCash: item.ledger.idBankCash,
                        };

                        const costCenters: ICostCenterAllocation[] = (item.cost_center_maps || []).map((map: any) => ({
                            costCenter: map.cost_center ? { value: map.cost_center.id_cost_centers, label: map.cost_center.name } : null,
                            costCenterId: map.id_cost_centers,
                            costCenterName: map.cost_center?.name,
                            amount: normalizeAmountInput(map.amount),
                            remarks: map.remarks ?? '',
                        }));

                        let voucherRows: ILedgerEntry = { 
                            idAccVoucherRows: item.id_acc_voucher_rows, 
                            ledger: ledger, 
                            drAmount: normalizeAmountInput(item.dr_amount), 
                            crAmount: normalizeAmountInput(item.cr_amount), 
                            remarks: item.remarks ?? '',
                            costCenters: costCenters,
                        };
                      
                        return voucherRows
                    })
                    setEntries(tempArray);
                    setHasLoadedVoucher(true);

                    getProjectSrs(resp.data.idProjects);
                    getCostCenters(resp.data.idProjects, tempArray);
                    if(resp.data.sales_representative !== null){
                        setSr({ label: resp.data.sales_representative.firstName+' '+resp.data.sales_representative.lastName, value: resp.data.sales_representative.id });
                    }else{
                        setSr({ label: 'Select SR', value: '' });
                    }

                    setCompanySelectAbility(false)
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    useEffect(() => {
        if (!show && !hasLoadedVoucher) {
            setEntries([createEmptyEntry()]);
            setCostCenterRows([createEmptyCostCenterRow()]);
        }
    }, [show, hasLoadedVoucher]);

    const getCostCenters = (idProjects: string | number, currentEntries: ILedgerEntry[] = entries) => {
        const params = new URLSearchParams();
        if (idProjects) {
            params.append('idProjects', String(idProjects));
        }
        const url = `${process.env.REACT_APP_API_URL}cost-centers${params.toString() ? `?${params.toString()}` : ''}`;
        fetch(url, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const options = (resp?.data || []).map((item: any) => ({
                    label: item.name,
                    value: item.idCostCenters,
                }));

                const existingSelections: any[] = [];
                currentEntries.forEach((entry) => {
                    (entry.costCenters || []).forEach((allocation) => {
                        const value = allocation.costCenter?.value ?? allocation.costCenterId;
                        const label = allocation.costCenter?.label ?? allocation.costCenterName;
                        if (value && label) {
                            existingSelections.push({ value, label });
                        }
                    });
                });

                const merged = [...options];
                existingSelections.forEach((selection) => {
                    if (!merged.find((opt) => opt.value === selection.value)) {
                        merged.push(selection);
                    }
                });

                setCostCenterOptions(merged);
            })
            .catch((error) => {
                console.log(error, 'fetch cost centers error');
                setCostCenterOptions([]);
            });
    };

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getLedgers = (inputValue: any, callback: any, voucherType = '') => {
        voucherType = voucherType === '' ? formData.voucherType : voucherType;

        let url = '';
        if (!inputValue) {
            url = `${process.env.REACT_APP_API_URL}transaction/ledgers?type=` + voucherType+`&idProjects=`+formData.idProjects;
        }
        else {
            url = `${process.env.REACT_APP_API_URL}transaction/ledgers?type=` + voucherType+`&idProjects=`+formData.idProjects + `&q=` + inputValue;
        }
        setTimeout(() => {
            fetch(url,
                getRequestOptions())
                .then((resp) => {
                    return resp.json()
                })
                .then((resp) => {
                    if (resp.data !== null) {
                        let tempArray = resp.data.map(function (element: any) {
                            element.label = `${element.ledgerCode} ${element.ledgerName}`;
                            element.value = element.idAccLedgers;
                            // element.ledgerPath = element.ledgerPath;
                            return element;
                        });
                        setDefaultLedgers(tempArray);
                        callback(tempArray);
                    }
                    else {
                        callback([]);
                    }
                })
                .catch((error) => {
                    console.log(error, "catch the hoop")
                });
        })


    }

    const getProjectSrs = (idProjects: number) => {
        fetch(
            process.env.REACT_APP_API_URL + 'getAllSr?idProjects=' + idProjects,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let srsObj = resp.map((item: any) => {
                    item.label = item.first_name + ' ' + item.last_name;
                    item.value = item.id;
                    return item
                })
                setSrs(srsObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    // Handle project change
    const handleProjectChange = (project: any) => {
        setProject(project);
        if (project) {
            setFormData({
                ...formData,
                idProjects: project.value,
                voucherDate: clampToInventoryDateBounds(formData.voucherDate, resolveAccountingBackdateDays(project)),
            });
            getProjectSrs(project.value);
            getCostCenters(project.value, entries);
            setEntries((prev) => prev.map((entry) => ({ ...entry, costCenters: [] })));
            setCostCenterRows([createEmptyCostCenterRow()]);
        } else {
            setFormData({ ...formData, idProjects: '' });
            setCostCenterOptions([]);
            setEntries((prev) => prev.map((entry) => ({ ...entry, costCenters: [] })));
            setCostCenterRows([createEmptyCostCenterRow()]);
        }

        setCompanySelectAbility(false)
    }

    const handleSrChange = (sr: any) => {
        setSr(sr);
        setFormData({ ...formData, idSr: sr.value });
    }

    // Handle voucher type change
    const handleVoucherTypeChange = (voucherType: any) => {
        setVoucherType(voucherType);
        const isJournal = voucherType?.value === 'journal';
        if (isJournal) {
            setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
        }
        setFormData({
            ...formData,
            voucherType: voucherType.value,
            ...(isJournal ? {
                idModeOfTransaction: null,
                chequeNo: '',
                chequeDate: '',
                transactionDate: '',
            } : {}),
        });
        setEntries([createEmptyEntry()]);
        setCostCenterRows([createEmptyCostCenterRow()]);
        getLedgers('', (data: any) => { }, voucherType.value);
    };

    const handleModeOfTransactionChange = (selected: any) => {
        if (!selected) {
            setModeOfTransaction({ label: 'Select Mode of Transaction', value: '' });
            setFormData((prev) => ({
                ...prev,
                idModeOfTransaction: null,
                chequeNo: '',
                chequeDate: '',
                transactionDate: '',
            }));
            return;
        }
        setModeOfTransaction(selected);
        const cheque = isChequeMode(selected);
        setFormData((prev) => ({
            ...prev,
            idModeOfTransaction: selected.value,
            chequeNo: cheque ? prev.chequeNo : '',
            chequeDate: cheque ? prev.chequeDate : '',
            transactionDate: cheque ? '' : prev.transactionDate,
        }));
    };

    // Handle input changes
    const handleInputChange = (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newEntries = [...entries];
        const { name, value } = event.target;

        const currentEntry = { ...newEntries[index] };
        if (name === 'drAmount') {
            currentEntry.drAmount = value;
            currentEntry.crAmount = ''; // Clearing Credit Amount if Debit Amount is entered
        } else if (name === 'crAmount') {
            currentEntry.crAmount = value;
            currentEntry.drAmount = ''; // Clearing Debit Amount if Credit Amount is entered
        } else if (name === 'remarks') {
            currentEntry.remarks = value;
        } else {
            return;
        }

        newEntries[index] = currentEntry; // Correctly updating the entry at the given index
        setEntries(newEntries);

    };

    // Handle adding new row
    const handleAddRow = () => {
        setEntries([...entries, createEmptyEntry()]);
    };

    // Handle removing row
    const handleRemoveRow = (index: number) => {
        const newEntries = [...entries];
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to remove this row?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, remove it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.isConfirmed) {
                newEntries.splice(index, 1);
                setEntries(newEntries);
            }
        })
      
    };

    // Handle ledger change
    const handleLedgerChange = (selectedOption: any, index: number) => {
        const updatedEntries = entries.map((entry, idx) => {
            if (idx === index) {
                return { ...entry, ledger: selectedOption, drAmount: '', crAmount: '', costCenters: [] };
            }
            return entry;
        });

        setEntries(updatedEntries);
        setCostCenterRows([createEmptyCostCenterRow()]);
    };

    const handleOpenCostCenterModal = (index: number) => {
        if (!entries[index]?.ledger) {
            toast('Please select a ledger first.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
            return;
        }
        if (!formData.idProjects) {
            toast('Please select a project first.', { type: 'error', position: 'bottom-right', autoClose: 3000 });
            return;
        }
        if (!costCenterOptions.length) {
            getCostCenters(formData.idProjects, entries);
        }
        setActiveCostCenterIndex(index);
        const existing = entries[index]?.costCenters || [];
        const rows = existing.length
            ? existing.map((row) => {
                const resolvedOption =
                    costCenterOptions.find((opt) => opt.value === (row.costCenter?.value ?? row.costCenterId)) ||
                    row.costCenter ||
                    (row.costCenterId ? { value: row.costCenterId, label: row.costCenterName } : null);
                return {
                    costCenter: resolvedOption,
                    costCenterId: resolvedOption?.value ?? row.costCenterId,
                    costCenterName: resolvedOption?.label ?? row.costCenterName,
                    amount: normalizeAmountInput(row.amount),
                    remarks: row.remarks ?? '',
                };
            })
            : [createEmptyCostCenterRow()];
        setCostCenterRows(rows);
        setShowCostCenterModal(true);
    };

    const handleCostCenterFieldChange = (index: number, field: 'costCenter' | 'amount' | 'remarks', value: any) => {
        setCostCenterRows((prev) => {
            const rows = [...prev];
            const row = { ...rows[index] };
            if (field === 'costCenter') {
                row.costCenter = value;
                row.costCenterId = value?.value;
                row.costCenterName = value?.label;
            } else {
                row[field] = field === 'amount' ? normalizeAmountInput(value) : value;
            }
            rows[index] = row;
            return rows;
        });
    };

    const handleAddCostCenterRow = () => {
        setCostCenterRows((prev) => [...prev, createEmptyCostCenterRow()]);
    };

    const handleRemoveCostCenterRow = (index: number) => {
        setCostCenterRows((prev) => {
            const rows = [...prev];
            rows.splice(index, 1);
            return rows.length ? rows : [createEmptyCostCenterRow()];
        });
    };

    const handleSaveCostCenters = () => {
        if (activeCostCenterIndex === null) {
            return;
        }
        const sanitized = costCenterRows
            .filter((row) => (row.costCenter || row.costCenterId) && row.amount !== '')
            .map((row) => ({
                costCenter: row.costCenter,
                costCenterId: row.costCenter?.value ?? row.costCenterId,
                costCenterName: row.costCenter?.label ?? row.costCenterName,
                amount: normalizeAmountInput(row.amount),
                remarks: row.remarks,
            }));

        const ledgerEntry = entries[activeCostCenterIndex];
        const ledgerAmount = Number(ledgerEntry?.drAmount || ledgerEntry?.crAmount || 0);
        const totalCostCenterAmount = sanitized.reduce((sum, row) => sum + Number(row.amount || 0), 0);
        if (sanitized.length && Math.abs(totalCostCenterAmount - ledgerAmount) > 0.0001) {
            toast(
                <strong>
                    Cost center total ({numberFormat(totalCostCenterAmount)}) must equal ledger amount ({numberFormat(ledgerAmount)})
                </strong>,
                { type: 'error', position: 'bottom-right', autoClose: 4000 }
            );
            return;
        }

        setEntries((prev) => {
            const updated = [...prev];
            updated[activeCostCenterIndex] = {
                ...updated[activeCostCenterIndex],
                costCenters: sanitized,
            };
            return updated;
        });
        setShowCostCenterModal(false);
        setActiveCostCenterIndex(null);
        setCostCenterRows([createEmptyCostCenterRow()]);
    };

    const handleCloseCostCenterModal = () => {
        setShowCostCenterModal(false);
        setActiveCostCenterIndex(null);
        setCostCenterRows([createEmptyCostCenterRow()]);
    };


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: name === 'voucherDate'
                ? clampToInventoryDateBounds(value, resolveAccountingBackdateDays(selectedProject || project))
                : value,
        });
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const dateError = inventoryDateError(formData.voucherDate, resolveAccountingBackdateDays(selectedProject || project));
        if (dateError) {
            toast(<strong>{dateError}</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
            return;
        }
        setLoading(true);
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const costCenters = entry.costCenters || [];
            if (costCenters.length > 0) {
                const ledgerAmount = Number(entry.drAmount || entry.crAmount || 0);
                const totalCostCenterAmount = costCenters.reduce((sum, cc) => sum + Number(cc.amount || 0), 0);
                if (Math.abs(totalCostCenterAmount - ledgerAmount) > 0.0001) {
                    toast(<strong>Row {i + 1}: Cost center amounts must equal the ledger amount.</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                    setLoading(false);
                    return;
                }
            }
        }

        const mappedEntries = entries.map((entry: ILedgerEntry) => {
            const sanitizedCostCenters = (entry.costCenters || [])
                .filter((row: ICostCenterAllocation) => (row.costCenter || row.costCenterId) && row.amount !== '')
                .map((row: ICostCenterAllocation) => ({
                    costCenterId: row.costCenter?.value ?? row.costCenterId,
                    amount: normalizeAmountInput(Number(row.amount)),
                    remarks: row.remarks,
                }));

            const mappedEntry: any = {
                idAccVoucherRows: entry.idAccVoucherRows,
                ledger: entry.ledger,
                drAmount: entry.drAmount,
                crAmount: entry.crAmount,
                remarks: entry.remarks,
                costCenters: sanitizedCostCenters,
            };

            return mappedEntry;
        });
        // Correctly constructing postData
        const postData = {
            ...formData,  // Spreads all formData properties
            entries: mappedEntries // Adds entries array
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'transaction/update', postRequestOptions(postData));

            const data = await response.json();
            // console.log(data, 'data');

            if (data.success) {
                toast(<strong>Voucher updated successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                handleClose(false);
            } else {

                if (data?.errorMessage) {
                    toast(data?.errorMessage, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }

                for (const i in data.errors) {
                    toast(<strong>{data.errors[i].join(' ')}</strong>, { type: 'error', position: 'bottom-right', autoClose: 4000 });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const drAmountTotal = entries.reduce((acc, entry) => {
        return acc + Number(entry.drAmount || 0);
    }, 0);
    
    const crAmountTotal = entries.reduce((acc, entry) => {
        return acc + Number(entry.crAmount || 0);
    }, 0);

    const selectedProject = projects.find((item: any) => String(item.value) === String(project?.value || formData.idProjects)) || project;
    const dateBounds = getInventoryDateBounds(resolveAccountingBackdateDays(selectedProject));

    return (
        <>
            <Modal show={show} onHide={() => handleClose(false)} fullscreen={true} animation={true} dialogClassName="modal-dialog-scrollable">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Voucher</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body className="modal-body-custom" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-warning" role="alert">
                                    Please add payment against sales from <Link to={`/sales-invoices`} className="text-primary">Invoice page</Link> or <Link to={`/sales-order-create`} className="text-primary">Sales Order page.</Link>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="offset-md-2 col-md-6">
                                <Form.Group className="mb-3 row" controlId="project">
                                    <Form.Label className='col-md-4 text-end'>Project<span className="required text-danger"></span></Form.Label>
                                    <div className="col-md-8">
                                        <Select
                                            value={project}
                                            onChange={handleProjectChange}
                                            options={projects}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="offset-md-2 col-md-6">
                                <Form.Group className="mb-3 row" controlId="sr">
                                    <Form.Label className='col-md-4 text-end'>Select SR</Form.Label>
                                    <div className="col-md-8">
                                        <Select
                                            value={sr}
                                            onChange={handleSrChange}
                                            options={srs}
                                            isDisabled={companySelectAbility}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row">
                            <div className="offset-md-2 col-md-6">
                                <Form.Group className="mb-3 row" controlId="voucherType">
                                    <Form.Label className='col-md-4 text-end'>Voucher Type</Form.Label>
                                    <div className="col-md-8">
                                        <Select
                                            value={voucherType}
                                            onChange={handleVoucherTypeChange}
                                            options={voucherTypes}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            isDisabled={id !== 0}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        <div className="row mb-5">
                            <div className="offset-md-2 col-md-6">
                                <Form.Group className='row' controlId="voucherDate">
                                    <Form.Label className='mb-3 col-md-4 text-end'>Date<span className="required text-danger"></span></Form.Label>
                                    <div className="col-md-8">
                                        <Form.Control
                                            type="date"
                                            name="voucherDate"
                                            value={formData.voucherDate}
                                            min={dateBounds.minDate || undefined}
                                            max={dateBounds.maxDate}
                                            onChange={handleChange}
                                            className='form-control-sm'
                                            disabled={!formData.idProjects}
                                            required
                                        />
                                        <div className="form-text text-muted mt-1">
                                            {inventoryDateHint(!!formData.idProjects, resolveAccountingBackdateDays(selectedProject))}
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {formData.voucherType !== 'journal' && (
                            <>
                                <div className="row">
                                    <div className="offset-md-2 col-md-6">
                                        <Form.Group className="mb-3 row" controlId="modeOfTransaction">
                                            <Form.Label className='col-md-4 text-end'>Mode of Transaction</Form.Label>
                                            <div className="col-md-8">
                                                <Select
                                                    value={modeOfTransaction.value ? modeOfTransaction : null}
                                                    onChange={handleModeOfTransactionChange}
                                                    options={modeOfTransactions}
                                                    isClearable
                                                    placeholder="Select Mode of Transaction"
                                                    menuPosition="fixed"
                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                {isChequeMode(modeOfTransaction) && (
                                    <>
                                        <div className="row">
                                            <div className="offset-md-2 col-md-6">
                                                <Form.Group className="mb-3 row" controlId="chequeNo">
                                                    <Form.Label className='col-md-4 text-end'>Cheque No</Form.Label>
                                                    <div className="col-md-8">
                                                        <Form.Control
                                                            type="text"
                                                            name="chequeNo"
                                                            value={formData.chequeNo}
                                                            onChange={handleChange}
                                                            className='form-control-sm'
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="offset-md-2 col-md-6">
                                                <Form.Group className="mb-3 row" controlId="chequeDate">
                                                    <Form.Label className='col-md-4 text-end'>Cheque Date</Form.Label>
                                                    <div className="col-md-8">
                                                        <Form.Control
                                                            type="date"
                                                            name="chequeDate"
                                                            value={formData.chequeDate}
                                                            onChange={handleChange}
                                                            className='form-control-sm'
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {modeOfTransaction.value && !isChequeMode(modeOfTransaction) && (
                                    <div className="row mb-5">
                                        <div className="offset-md-2 col-md-6">
                                            <Form.Group className="mb-3 row" controlId="transactionDate">
                                                <Form.Label className='col-md-4 text-end'>Transaction Date</Form.Label>
                                                <div className="col-md-8">
                                                    <Form.Control
                                                        type="date"
                                                        name="transactionDate"
                                                        value={formData.transactionDate}
                                                        onChange={handleChange}
                                                        className='form-control-sm'
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        <Table bordered responsive>
                            <thead>
                                <tr>
                                    <th style={{ width: '40%' }}>General Ledger</th>
                                    <th style={{ width: '10%' }}>Dr Amount (Tk)</th>
                                    <th style={{ width: '10%' }}>Cr Amount (Tk)</th>
                                    <th style={{ width: '20%' }}>Remarks</th>
                                    <th style={{ width: '10%' }}>Cost Centers</th>
                                    <th style={{ width: '10%' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {entries.map((entry, index) => (
                                    <tr key={index}>
                                        <td>
                                            <AsyncSelect<any, false>
                                                value={entry.ledger}
                                                loadOptions={getLedgers as any}
                                                placeholder="Please select ledger"
                                                defaultOptions={defaultLedgers}
                                                onChange={(selectedOption) => handleLedgerChange(selectedOption, index)}
                                                menuPosition="fixed"
                                                isClearable
                                                components={{ SingleValue: LedgerSingleValue }}
                                                getOptionLabel={(option: any) => option.label ?? ''}
                                                formatOptionLabel={(option: any) => (
                                                    <>
                                                        <i className='fa fa-file'></i>
                                                        <span> {option.label} </span><br />
                                                        <i className='fa fa-map-marker'></i>
                                                        <span> {option.ledgerPath} </span>
                                                    </>
                                                )}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                name="drAmount"
                                                value={entry.drAmount}
                                                onChange={(e) => handleInputChange(index, e)}
                                                min={0}
                                                step="any"
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                name="crAmount"
                                                value={entry.crAmount}
                                                onChange={(e) => handleInputChange(index, e)}
                                                min={0}
                                                step="any"
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                name="remarks"
                                                value={entry.remarks}
                                                onChange={(e) => handleInputChange(index, e)}
                                            />
                                        </td>
                                        <td>
                                            <div className="d-flex flex-column">
                                                <button
                                                    type="button"
                                                    className={`btn btn-link btn-sm p-0 align-baseline ${!entry.ledger ? 'text-muted' : ''}`}
                                                    disabled={!entry.ledger}
                                                    onClick={() => handleOpenCostCenterModal(index)}
                                                >
                                                    <i className='fa fa-tags me-1'></i>
                                                    {entry.costCenters.length ? `Cost Centers (${entry.costCenters.length})` : 'Tag Cost Center'}
                                                </button>
                                                {entry.costCenters.length > 0 && (
                                                    <div className="small text-muted">
                                                        {entry.costCenters
                                                            .map((cc) => {
                                                                const name = cc.costCenter?.label ?? cc.costCenterName ?? '';
                                                                const amount = numberFormat(Number(cc.amount || 0));
                                                                return name ? `${name}${amount ? ` (${amount})` : ''}` : amount;
                                                            })
                                                            .filter((text) => text && text.trim().length > 0)
                                                            .join(', ')}
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex'>
                                                {entries.length > 1 && (
                                                    <Button className='btn btn-sm ms-2' variant="danger" onClick={() => handleRemoveRow(index)}>
                                                        <i className='fa fa-trash'></i>
                                                    </Button>
                                                )}

                                                {index === entries.length - 1 && (
                                                    <Button className='btn btn-sm ms-2' variant="primary" onClick={handleAddRow}>
                                                        <i className='fa fa-plus'></i>
                                                    </Button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td className="text-end"><strong>Total</strong></td>
                                    <td><strong>{numberFormat(drAmountTotal)}</strong></td>
                                    <td><strong>{numberFormat(crAmountTotal)}</strong></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </Table>

                        <Form.Group controlId="formNarration">
                            <Form.Label>Narration</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="narration"
                                value={formData.narration}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" disabled={isSubmitDisable || loading} className="btn btn-sm btn-primary me-2">
                            {loading && (
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            <span> <i className='fa fa-save'></i> Update</span>
                        </button>
                        <Button variant='secondary' size="sm" onClick={() => handleClose(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                    {/* <pre>{JSON.stringify(formData, null, 2)}</pre>
                    <pre>{JSON.stringify(entries, null, 2)}</pre> */}
                </Form>
            </Modal>

            <Modal show={showCostCenterModal} onHide={handleCloseCostCenterModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Tag Cost Center</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered responsive size="sm">
                        <thead>
                            <tr>
                                <th style={{ width: '40%' }}>Cost Center</th>
                                <th style={{ width: '20%' }}>Amount</th>
                                <th style={{ width: '30%' }}>Remarks</th>
                                <th style={{ width: '10%' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {costCenterRows.map((row, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <Select
                                            value={row.costCenter}
                                            onChange={(option) => handleCostCenterFieldChange(idx, 'costCenter', option)}
                                            options={costCenterOptions}
                                            placeholder="Select cost center"
                                            isClearable
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            min={0}
                                            step="any"
                                            value={row.amount}
                                            onChange={(e) => handleCostCenterFieldChange(idx, 'amount', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={row.remarks}
                                            onChange={(e) => handleCostCenterFieldChange(idx, 'remarks', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <div className='d-flex'>
                                            {costCenterRows.length > 1 && (
                                                <Button variant="danger" size="sm" onClick={() => handleRemoveCostCenterRow(idx)}>
                                                    <i className='fa fa-trash'></i>
                                                </Button>
                                            )}
                                            {idx === costCenterRows.length - 1 && (
                                                <Button variant="primary" size="sm" className='ms-2' onClick={handleAddCostCenterRow}>
                                                    <i className='fa fa-plus'></i>
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' size="sm" onClick={handleCloseCostCenterModal}>
                        Close
                    </Button>
                    <Button variant='primary' size="sm" onClick={handleSaveCostCenters}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default VoucherEdit